import {PhoneHQRadioRow, PhoneHQGlyph, PhoneHQLoader, PhoneHQButton, PhoneHQConfirmDialog, PhoneHQModal, PhoneHQSwitch} from 'ch3-ui-lib';
import {useEffect, useState} from "react";
import ForwardCall from "./Modal/ForwardCall";
import { parsePhoneNumber} from "libphonenumber-js";
import {Link, useNavigate, useParams} from "react-router-dom";
import {FlagImage} from "react-international-phone";
import {getFlag} from "../../utilis/msisdnUtilis";
import {MessageDialog, type TtsSettings} from "../../components/MessageDialog/MessageDialog";
import AudioPlayer from "../../components/AudioPlayer/AudioPlayer";
import useMediaQuery from "../../utilis/screenWidthUtils.ts";
import {
    AudioFilesURL, CallRulesDTO,
    useFetchCallRulesQuery,
    useGetRecordingQuery, usePostRecordingPreviewMutation, useSynthetizeTextMutation,
    useUpdateCallRulesMutation, useUploadSynthetizeTextMutation, CallRulesStateEnum
} from "../../store/features/MsisdnSettings/msisdnSettingsService";

import {CallQueueModal} from "./Modal/CallQueueModal";
import {useGetQueueByIdQuery} from "../../store/features/CallQueue/CallQueueService";
import parsePhoneNumberFromString from "libphonenumber-js/max";

interface CallRulesProps {
    admin?: boolean;
}
const CallRules = ({admin}:CallRulesProps ) => {

    const {id} = useParams<{ id: string }>() as { id: string };
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width: 960px)');
    const [savedWMTts, setSavedWMTts] = useState<TtsSettings>();
    const [savedAHTts, setSavedAHTts] = useState<TtsSettings>();
    const [savedVMts, setSavedVMts] = useState<TtsSettings>();


    const [queueDraft, setQueueDraft] = useState<number | null>(null);

    const [pendingUpload, setPendingUpload] = useState<string>('');

    const [postRecordingPreview, {data: tempFile}] = usePostRecordingPreviewMutation();

    const [synthetizeText, { data: tempTtsFile }] = useSynthetizeTextMutation();

    const [postSynthTextPreview, {data: synthText}] = useUploadSynthetizeTextMutation();

    const {data: callRules, isLoading} = useFetchCallRulesQuery(id);
    const {data: afterHoursAudioUrl, isLoading: isLoadingAfterHorus} = useGetRecordingQuery({id, type: CallRulesStateEnum.AFTER_HOURS_MESSAGE});
    const {data: workingHoursAudioUrl,  isLoading: isLoadingWelcome} = useGetRecordingQuery({id, type: CallRulesStateEnum.WORKING_HOURS_WELCOME_MESSAGE});

    const [forwardMsisdnWorkingDraft, setForwardMsisdnWorkingDraft] = useState<string>('');
    const [forwardMsisdnNotWorkingDraft, setForwardMsisdnNotWorkingDraft] = useState<string>('');

    const {data: voiceMailAudioUrl, isLoading: isLoadingVoiceMail} = useGetRecordingQuery({id, type: CallRulesStateEnum.VOICEMAIL_GREETING});

    const [updateCallRules] = useUpdateCallRulesMutation();

    const initialState: CallRulesDTO = {
        msisdnId: undefined,
        workingForwardEnabled: false,
        workingForwardMsisdn: null,
        workingWelcomeMessageEnabled: false,
        nonWorkingForwardEnabled: false,
        nonWorkingForwardMsisdn: null,
        nonWorkingDontAcceptCalls: false,
        nonWorkingAfterHoursMessageEnabled: false,
        nonWorkingAfterHoursMessageOriginalName: null,
        nonWorkingAfterHoursMessageBucketName: null,
        nonWorkingWelcomeMessageBucketName: null,
        workingWelcomeMessageOriginalName: null,
        workingWelcomeMessageBucketName: null,
        queueEnabled: false,
        queueId: null,
        voicemailEnabled: false,
        voicemailGreetingOriginalName: null,
        voicemailGreetingBucketName: null,
    };

    const [formData, setFormData] = useState(initialState);

    const {data: selectedQueue} = useGetQueueByIdQuery(Number(formData?.queueId), {skip: !formData?.queueId});

    useEffect(() => {
        if (callRules) {
            setFormData(callRules as CallRulesDTO);
            setForwardMsisdnWorkingDraft(callRules.workingForwardMsisdn?.toString() ?? '');
            setForwardMsisdnNotWorkingDraft(callRules.nonWorkingForwardMsisdn?.toString() ?? '');
        }
    }, [callRules]);

    useEffect(() => {

        if (pendingUpload == 'welcomeMessageWorking' && tempFile) {
            setAudioURL((prevState) => ({
                ...prevState,
                workingWelcomeMessageUrl: tempFile.audioURL
            }));
            setFormData(prevState =>
                ({
                    ...prevState,
                    workingWelcomeMessageEnabled: true,
                    workingWelcomeMessageOriginalName: tempFile.originalFileName,
                    workingWelcomeMessageBucketName: tempFile.bucketFileName,
                }));

            setPendingUpload('');
        }
        if (pendingUpload == 'afterHoursMessage' && tempFile) {
            setAudioURL((prevState) => ({
                ...prevState,
                nonWorkingWelcomeMessageUrl: tempFile.audioURL
            }));
            setFormData(prevState =>
                ({
                    ...prevState,
                    nonWorkingAfterHoursMessageEnabled: true,
                    nonWorkingAfterHoursMessageOriginalName: tempFile.originalFileName,
                    nonWorkingAfterHoursMessageBucketName: tempFile.bucketFileName,
                }));
            setPendingUpload('');
        }
        if (pendingUpload == 'voiceMail' && tempFile) {
            setAudioURL((prevState) => ({
                ...prevState,
                voicemailGreetingUrl: tempFile.audioURL
            }));
            setFormData(prevState =>
                ({
                    ...prevState,
                    voicemailEnabled: true,
                    voicemailGreetingOriginalName: tempFile.originalFileName,
                    voicemailGreetingBucketName: tempFile.bucketFileName,
                }));
            setPendingUpload('');
        }
    }, [tempFile, pendingUpload]);

    useEffect(() => {

        if (pendingUpload == 'welcomeMessageWorking' && synthText) {
            setAudioURL((prevState) => ({
                ...prevState,
                workingWelcomeMessageUrl: tempTtsFile.data
            }));
            setFormData(prevState =>
                ({
                    ...prevState,
                    workingWelcomeMessageEnabled: true,
                    workingWelcomeMessageOriginalName: synthText.originalFileName,
                    workingWelcomeMessageBucketName: synthText.bucketFileName,
                    workingForwardEnabled: false,
                }));

            setPendingUpload('');
        }
        if (pendingUpload == 'afterHoursMessage' && synthText) {
            setAudioURL((prevState) => ({
                ...prevState,
                nonWorkingWelcomeMessageUrl: tempTtsFile.data
            }));
            setFormData(prevState =>
                ({
                    ...prevState,
                    nonWorkingAfterHoursMessageEnabled: true,
                    nonWorkingAfterHoursMessageOriginalName: synthText.originalFileName,
                    nonWorkingAfterHoursMessageBucketName: synthText.bucketFileName,
                    nonWorkingForwardEnabled: false,
                    nonWorkingDontAcceptCalls: false
                }));
            setPendingUpload('');
        }
        if (pendingUpload == 'voiceMail' && synthText) {
            setAudioURL((prevState) => ({
                ...prevState,
                voicemailGreetingUrl: tempTtsFile.data
            }));
            setFormData(prevState =>
                ({
                    ...prevState,
                    voicemailEnabled: true,
                    voicemailGreetingOriginalName: synthText.originalFileName,
                    voicemailGreetingBucketName: synthText.bucketFileName,
                    
                }));

            setPendingUpload('');
        }
    }, [synthText, pendingUpload]);

    const [audioURL, setAudioURL] = useState<AudioFilesURL>({
        workingWelcomeMessageUrl: workingHoursAudioUrl?.data,
        nonWorkingWelcomeMessageUrl: afterHoursAudioUrl?.data,
        voicemailGreetingUrl: voiceMailAudioUrl?.data
    });
    useEffect(() => {

        setAudioURL({
            workingWelcomeMessageUrl: workingHoursAudioUrl?.data,
            nonWorkingWelcomeMessageUrl: afterHoursAudioUrl?.data,
            voicemailGreetingUrl: voiceMailAudioUrl?.data
        });
    }, [afterHoursAudioUrl, workingHoursAudioUrl, voiceMailAudioUrl]);


    const welcomeMessageWorking = {
        label: 'Welcome message',
        description: 'Create a friendly greeting for callers to enhance their experience.',
        url: audioURL.workingWelcomeMessageUrl,
        isEnabled: formData?.workingWelcomeMessageEnabled,
    }


    const callOptions = {
        afterHoursMessage: {
            label: 'After hours message',
            description: 'Create a friendly greeting for callers to enhance their experience.',
            url: audioURL.nonWorkingWelcomeMessageUrl,
            isEnabled: formData?.nonWorkingAfterHoursMessageEnabled,
        },
        forwardWorking: {
            label: 'Forward call',
            description: 'Calls will be forwarded to the specified phone number.',
            url: audioURL.workingWelcomeMessageUrl,
            isEnabled: formData?.workingForwardEnabled,
        },
        forwardNonWorking: {
            label: 'Forward call',
            description: 'Calls will be forwarded to the specified phone number.',
            url: audioURL.workingWelcomeMessageUrl,
            isEnabled: formData?.nonWorkingForwardEnabled,
        },
        receiveIncomingCall: {
            label: 'Receive incoming calls',
            description: 'You will answer the incoming call.',
        },
        dontAcceptCals: {
            label: 'Don’t accept calls',
            description: 'Callers receive a busy signal.',
        },
        callQueue: {
            label: 'Call queue',
            description: 'The call will be routed to the appropriate queue based on predefined criteria.',
        },
        voiceMail: {
            label: 'Voicemail',
            description: 'Calls will be redirected to voicemail if you don`t answer or reject them',
            url: audioURL.voicemailGreetingUrl,
            isEnabled: formData?.voicemailEnabled,
        }

    }

    // Which dialog is open. Rows still call `ref.current.openModal()`, so each gets a small opener.
    const [openDialog, setOpenDialog] = useState<null | 'welcome' | 'afterHours' | 'voiceMail' | 'forwardWorking' | 'forwardNonWorking' | 'queue'>(null);
    const opener = (dialog: NonNullable<typeof openDialog>) => ({current: {openModal: () => setOpenDialog(dialog)}});
    const closeDialog = () => setOpenDialog(null);
    const welcomeMessageWorkingRef = opener('welcome');
    const afterHoursMessageRef = opener('afterHours');
    const forwardCallWorkingRef = opener('forwardWorking');
    const forwardCallNonWorkingRef = opener('forwardNonWorking');
    const callQueueRef = opener('queue');

    const voiceMailRef = opener('voiceMail');

    const isAudioLoading = (type: string) => {
        if (type === 'welcomeMessageWorking') {
            return isLoadingWelcome;
        }
        if (type === 'afterHoursMessage') {
            return isLoadingAfterHorus;
        }
        if (type === 'voiceMail') {
            return isLoadingVoiceMail;
        }
    }

    const switchTypes = ['welcomeMessageWorking', 'afterHoursMessage', 'voiceMail'];

    const getCallOption = (label: string, description: string, isEnabled: boolean, type: string, ref: any, element: any, callback?: () => void, url?: string | undefined) => {
        const item = {
            id: type,
            value: type,
            label: label,
            description: description,
        }
        return (
            <div
                id={type}
                className={`mt-2 scroll-mt-4 cursor-pointer rounded-[12px] border border-solid border-line bg-surface p-4 hover:border-brand-disabled`}>
                <div className='flex justify-between items-start'>
                { switchTypes.includes(type) &&
                        <>
                            {!isAudioLoading(type) && <div className="flex ">
                                <div className="max-w-[100px] mr-3">

                                    <PhoneHQSwitch checked={isEnabled}
                                            onCheckedChange={() => {
                                                if (type === 'voiceMail' && !isEnabled) {
                                                    ref.current?.openModal() 
                                                    return;
                                                }
                                                if (!isEnabled && ref && !url) {
                                                    ref.current?.openModal()
                                                } else if (callback) {
                                                    callback()
                                                }
                                               
                                            }}
                                            switchFirst/>
                                </div>
                                <div className="flex flex-col">
                                    <div className='text-callout font-semibold text-ink'>{label}</div>
                                    <div
                                        className='text-footnote text-ink-muted items-center'>{description}</div>
                                </div>
                            </div>}
                            {isAudioLoading(type) &&

                                <div className={' items-start'}>
                                    <PhoneHQLoader className={'!h-[74px] w-full'} />
                                </div>
                            }
                        </>
                    }
                    { !switchTypes.includes(type) &&
                        <PhoneHQRadioRow
                            checked={Boolean(isEnabled)}
                            label={item.label}
                            description={item.description}
                            onSelect={() => {
                                if (!isEnabled && ref && !url) {
                                    ref.current?.openModal()
                                }
                                if (callback) {
                                    callback()
                                }
                            }}
                        />
                    }

                    {isEnabled && element && <PhoneHQButton variant="secondary-contrast" onClick={(e) => {
                                                         ref.current?.openModal()
                                                         e.stopPropagation()
                                                     }
                                                     } className='pr-3'>Change</PhoneHQButton>}
                </div>
                {isEnabled && element}
            </div>

        )
    }

    const getAudioPlayer = (url: string | undefined, isEnabled: boolean, fileName: string) => {
        return (
            url &&
            <div className='mt-4' onClick={event => event.stopPropagation()}>
                <AudioPlayer disabled={!isEnabled} src={url} filename={fileName}/>
            </div>

        )
    }

    const getForwardNumber = (phoneNumber: number | null) => {
        return (
            phoneNumber &&
            <div className='mt-4 text-sm font-medium'>
                Phone number:
                <div className='flex bg-canvas text-ink-muted p-3 items-center gap-2 text-sm'>
                    <FlagImage className='w-4 h-4'
                               iso2={getFlag(phoneNumber) ?? 'us'}/>
                    <div>{parsePhoneNumber(`+${phoneNumber}`).formatNational()}</div>
                </div>
            </div>);
    }
    const nonWorkingDontAcceptCallsChange = () => {

        setFormData(prevState =>
            ({
                ...prevState,
                nonWorkingDontAcceptCalls: true,
                nonWorkingForwardEnabled: false
            }));


    }
    const receiveIncomingCallChange = () => {
        setFormData(prevState =>
            ({
                ...prevState,
                workingForwardEnabled: false,
                queueEnabled: false,
                queueId: null,
            }));
    }
    const enableWelcomeMessage = () => {

        setFormData(prevState =>
            ({
                ...prevState,
                workingWelcomeMessageEnabled: !prevState.workingWelcomeMessageEnabled ,
            }));
    }
    const enableAfterHoursMessage = () => {

        setFormData(prevState =>
            ({
                ...prevState,
                nonWorkingAfterHoursMessageEnabled: !prevState.nonWorkingAfterHoursMessageEnabled,

            }));
    }

    const enableVoiceMail = () => {

        setFormData(prevState =>
            ({
                ...prevState,
                voicemailEnabled: !prevState.voicemailEnabled,

            }));
    }
    if (isLoading) {
        return (
            <div
                className={`flex w-full  ${isMobile ? ' px-4' : ''}`}>
                <PhoneHQLoader/>
            </div>
        )
    }


    const welcomeMessageAudioPlayer = getAudioPlayer(audioURL.workingWelcomeMessageUrl, formData.workingWelcomeMessageEnabled, 'workingWelcomeMessage');
    const welcomeMessageTrigger = getCallOption(welcomeMessageWorking.label, welcomeMessageWorking.description, welcomeMessageWorking.isEnabled, 'welcomeMessageWorking', welcomeMessageWorkingRef, welcomeMessageAudioPlayer, enableWelcomeMessage, welcomeMessageWorking.url);


    const forwardCallNumberElement = getForwardNumber(formData.workingForwardMsisdn);
    const forwardCallWorkingTrigger = getCallOption(callOptions.forwardWorking.label, callOptions.forwardWorking.description, callOptions.forwardWorking.isEnabled, 'forwardWorking', forwardCallWorkingRef, forwardCallNumberElement)

    const forwardCallNonWorkingElement = getForwardNumber(formData.nonWorkingForwardMsisdn);
    const forwardCallNonWorkingTrigger = getCallOption(callOptions.forwardNonWorking.label, callOptions.forwardNonWorking.description, callOptions.forwardNonWorking.isEnabled, 'forwardNonWorking', forwardCallNonWorkingRef, forwardCallNonWorkingElement)

    const isReceiveIncomingCallEnabled = !formData.workingForwardEnabled && !formData.queueEnabled;
    const receiveIncomingCallTrigger = getCallOption(callOptions.receiveIncomingCall.label, callOptions.receiveIncomingCall.description, isReceiveIncomingCallEnabled, 'receiveIncomingCall', undefined, undefined, receiveIncomingCallChange)

    const afterHoursMessageAudioPlayer = getAudioPlayer(audioURL.nonWorkingWelcomeMessageUrl, formData.nonWorkingAfterHoursMessageEnabled, 'afterHoursMessage');
    const afterHoursMessageTrigger = getCallOption(callOptions.afterHoursMessage.label, callOptions.afterHoursMessage.description, callOptions.afterHoursMessage.isEnabled, 'afterHoursMessage', afterHoursMessageRef, afterHoursMessageAudioPlayer, enableAfterHoursMessage, callOptions.afterHoursMessage.url);
    const voiceMailAudioPlayer = getAudioPlayer(audioURL.voicemailGreetingUrl, formData.voicemailEnabled, 'voiceMail');

    const dontAcceptCallsElement = getCallOption(callOptions.dontAcceptCals.label, callOptions.dontAcceptCals.description, formData.nonWorkingDontAcceptCalls, 'dontAcceptCalls', undefined, undefined, nonWorkingDontAcceptCallsChange);
    const voiceMailTrigger = getCallOption(callOptions.voiceMail.label, callOptions.voiceMail.description, callOptions.voiceMail?.isEnabled, 'voiceMail', voiceMailRef, voiceMailAudioPlayer, enableVoiceMail, callOptions.voiceMail.url);

    const callQueueElement = <div className='mt-4 text-sm font-medium'>
        <div className='flex bg-canvas text-ink p-2 items-center gap-3 text-sm rounded border border-line'>
            <PhoneHQGlyph name='library_add' size={20} className="text-ink-muted w-5 h-5"/>
            <div>{selectedQueue?.name}</div>
        </div>
    </div>
    const callQueueTrigger = getCallOption(callOptions.callQueue.label, callOptions.callQueue.description, formData.queueEnabled, 'callQueue', callQueueRef, callQueueElement);

    const setDraft = (val: string, type: string) => {
        switch (type) {
            case 'working':
                setForwardMsisdnWorkingDraft(val);
                break;
            case 'noWorking':
                setForwardMsisdnNotWorkingDraft(val);
                break;
        }
    }

    const checkIfIsValidPhoneNumber = (val: string, type: string) => {
        try {
            const parsedNumber = parsePhoneNumberFromString(`+${val.toString()}`);
            if( parsedNumber?.isValid() ) {
                setDraft(val, type);
            } else {
                setDraft('', type);
            }
        } catch (error) {
            setDraft('', type);
        }

    }
    const getContent = (type: string) => {
        return <ForwardCall
            msisdn={type == 'working' ? formData.workingForwardMsisdn : formData.nonWorkingForwardMsisdn} type={type}
            isValid={checkIfIsValidPhoneNumber}></ForwardCall>
    }

    const handleWorkingHoursForwardCall = (res: boolean) => {
        if (res) {
            if (forwardMsisdnWorkingDraft.length == 0) {
                setFormData(prevState =>
                    ({
                        ...prevState,
                        workingForwardEnabled: false,
                        workingForwardMsisdn: null
                    }));
                return;
            }
            setFormData(prevState =>
                ({
                    ...prevState,
                    workingForwardEnabled: true,
                    queueEnabled: false,
                    queueId: null,
                    workingForwardMsisdn: Number(forwardMsisdnWorkingDraft),
                }));
        }
    }
    const handleNotWorkingHoursForwardCall = (res: boolean) => {
        if (res) {
            if (forwardMsisdnNotWorkingDraft.length == 0) {
                setFormData(prevState =>
                    ({
                        ...prevState,
                        nonWorkingForwardEnabled: false,
                        nonWorkingForwardMsisdn: null

                    }));
                return;
            }
            setFormData(prevState =>
                ({
                    ...prevState,
                    nonWorkingForwardEnabled: true,
                    nonWorkingForwardMsisdn: Number(forwardMsisdnNotWorkingDraft),
                    nonWorkingDontAcceptCalls: false
                }));
        }
    }


    const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        const data = {
            ...formData,
            workingForwardMsisdn: formData.workingForwardMsisdn ? Number(formData.workingForwardMsisdn) : null,
            nonWorkingForwardMsisdn: formData.nonWorkingForwardMsisdn ? Number(formData.nonWorkingForwardMsisdn) : null,
        }
        if (!id) return;
        await updateCallRules({id, data});
        navigate((admin ? '/admin' : '' ) +  '/phoneNumbers');
    };

    const handleWelcomeMessageWorkingSubmit = (res: boolean) => {
        if (!res) return;
        setPendingUpload('welcomeMessageWorking');

    }

    const handleAfterHoursMessageSubmit = (res: boolean) => {
        if (!res) return;
        setPendingUpload('afterHoursMessage');
    }
    const handleVoiceMailSubmit = (res: boolean) => {
        if (!res) return;
        setPendingUpload('voiceMail');
    }
    const handleCallQueueSubmit = (res: boolean) => {
        if (!res) return;
        setFormData(prevState =>
            ({
                ...prevState,
                queueEnabled: true,
                queueId: queueDraft,
                workingForwardEnabled: false,
            }));
    }

    return (
        <>
            {formData &&
                <div className='w-full'>
                    <div>
                        <div
                            className={` overflow-x-hidden  overflow-y-auto ${isMobile ? ' px-4' : ''}`}>
                            <div
                                className={`flex flex-col   ${isMobile ? ' my-6 ' : ''} ` + 'border-line bg-surface'}>
                                <div>

                                    <h3 className='m-0 text-body-strong text-ink'>
                                        Call rules
                                    </h3>
                                    <div className='mt-1 pb-4 text-footnote text-ink-muted'>
                                        The incoming call will be displayed to users assigned to the number.
                                    </div>
                                </div>
                                <div className='flex flex-col gap-6 text-callout'>
                                    <section aria-label="When you work" className='flex flex-col'>
                                        <div>
                                            <div className='pb-1 text-caption text-ink-muted'>
                                                What happens when you work?
                                            </div>
                                            <div>{welcomeMessageTrigger}</div>
                                            <MessageDialog
                                                open={openDialog === 'welcome'}
                                                onOpenChange={(open) => !open && closeDialog()}
                                                title="Welcome message"
                                                audioFile={audioURL.workingWelcomeMessageUrl}
                                                savedTts={savedWMTts}
                                                setSavedTts={setSavedWMTts}
                                                uploadFile={postRecordingPreview}
                                                synthetizeText={synthetizeText}
                                                uploadSynthText={postSynthTextPreview}
                                                onSaved={() => handleWelcomeMessageWorkingSubmit(true)}
                                            />

                                        </div>
                                        {forwardCallWorkingTrigger}
                                        {callQueueTrigger}
                                        {receiveIncomingCallTrigger}

                                        <PhoneHQModal
                                            open={openDialog === 'forwardWorking'}
                                            onOpenChange={(open) => { if (!open) { closeDialog(); handleWorkingHoursForwardCall(false); } }}
                                            title="Forward call"
                                            footer={<>
                                                <PhoneHQButton variant="secondary" className="px-5" onClick={() => { closeDialog(); handleWorkingHoursForwardCall(false); }}>Cancel</PhoneHQButton>
                                                <PhoneHQButton className="px-5" disabled={!forwardMsisdnWorkingDraft} onClick={() => { closeDialog(); handleWorkingHoursForwardCall(true); }}>Confirm</PhoneHQButton>
                                            </>}
                                        >
                                            {getContent('working')}
                                        </PhoneHQModal>
                                        {formData.voicemailEnabled ? (
                                            <PhoneHQConfirmDialog open={openDialog === 'queue'} onOpenChange={(open) => !open && closeDialog()}
                                                                  title="Choose one feature" confirmLabel="OK" onConfirm={closeDialog}>
                                                Call Queue and Voicemail cannot operate simultaneously. Modify your configuration to resolve the conflict.
                                            </PhoneHQConfirmDialog>
                                        ) : (
                                            <PhoneHQModal
                                                open={openDialog === 'queue'}
                                                onOpenChange={(open) => !open && closeDialog()}
                                                title="Call queue"
                                                footer={<>
                                                    <PhoneHQButton variant="secondary" className="px-5" onClick={closeDialog}>Cancel</PhoneHQButton>
                                                    <PhoneHQButton className="px-5" onClick={() => { closeDialog(); handleCallQueueSubmit(true); }}>Confirm</PhoneHQButton>
                                                </>}
                                            >
                                                <CallQueueModal selectedQueue={selectedQueue} setQueue={setQueueDraft}/>
                                            </PhoneHQModal>
                                        )}
                                    </section>
                                    <section aria-label="After hours" className='flex flex-col'>
                                        <div className='pb-1 text-caption text-ink-muted'>
                                            What happens when you don't work?
                                        </div>
                                        {afterHoursMessageTrigger}
                                        <MessageDialog
                                            open={openDialog === 'afterHours'}
                                            onOpenChange={(open) => !open && closeDialog()}
                                            title="After hours message"
                                            audioFile={audioURL.nonWorkingWelcomeMessageUrl}
                                            savedTts={savedAHTts}
                                            setSavedTts={setSavedAHTts}
                                            uploadFile={postRecordingPreview}
                                            synthetizeText={synthetizeText}
                                            uploadSynthText={postSynthTextPreview}
                                            onSaved={() => handleAfterHoursMessageSubmit(true)}
                                        />
                                        {forwardCallNonWorkingTrigger}
                                        <PhoneHQModal
                                            open={openDialog === 'forwardNonWorking'}
                                            onOpenChange={(open) => { if (!open) { closeDialog(); handleNotWorkingHoursForwardCall(false); } }}
                                            title="Forward call"
                                            footer={<>
                                                <PhoneHQButton variant="secondary" className="px-5" onClick={() => { closeDialog(); handleNotWorkingHoursForwardCall(false); }}>Cancel</PhoneHQButton>
                                                <PhoneHQButton className="px-5" disabled={!forwardMsisdnNotWorkingDraft} onClick={() => { closeDialog(); handleNotWorkingHoursForwardCall(true); }}>Confirm</PhoneHQButton>
                                            </>}
                                        >
                                            {getContent('noWorking')}
                                        </PhoneHQModal>

                                        {dontAcceptCallsElement}


                                    </section>
                                </div>
                                <div className="mt-6">
                                    <div className='pb-1 text-caption text-ink-muted'>Voicemail</div>
                                    {voiceMailTrigger}
                                </div>
                                            {formData.queueEnabled ? (
                                                <PhoneHQConfirmDialog open={openDialog === 'voiceMail'} onOpenChange={(open) => !open && closeDialog()}
                                                                      title="Choose one feature" confirmLabel="OK" onConfirm={closeDialog}>
                                                    Call Queue and Voicemail cannot operate simultaneously. Modify your configuration to resolve the conflict.
                                                </PhoneHQConfirmDialog>
                                            ) : (
                                                <MessageDialog
                                                    open={openDialog === 'voiceMail'}
                                                    onOpenChange={(open) => !open && closeDialog()}
                                                    title="Voicemail greeting"
                                                    audioFile={audioURL.voicemailGreetingUrl}
                                                    savedTts={savedVMts}
                                                    setSavedTts={setSavedVMts}
                                                    uploadFile={postRecordingPreview}
                                                    synthetizeText={synthetizeText}
                                                    uploadSynthText={postSynthTextPreview}
                                                    onSaved={() => handleVoiceMailSubmit(true)}
                                                />
                                            )}
                                            
                            </div>
                            <div className={` flex justify-end border-t border-line`}>
                                <div className='flex gap-3 justify-end m-8'>
                                    <Link to={'/phoneNumbers'}><PhoneHQButton variant="secondary" size="lg" phq-id='phoneNumberRules-cancelBtn' >Cancel</PhoneHQButton></Link>
                                    <PhoneHQButton size="lg" onClick={(e) => handleSubmit(e)} phq-id='phoneNumberRules-saveBtn' >Done</PhoneHQButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}
export default CallRules;
